import { Component } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { CreateQuickPaymentTermsLookupComponent } from '../create-quick-payment-terms-lookup/create-quick-payment-terms-lookup.component';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-close-quick-payment-terms-lookup',
  standalone: true,
  imports: [SharedModule, CreateQuickPaymentTermsLookupComponent],
  templateUrl: './close-quick-payment-terms-lookup.component.html',
  styleUrl: './close-quick-payment-terms-lookup.component.scss'
})
export class CloseQuickPaymentTermsLookupComponent {

  constructor(public ref: DynamicDialogRef) { }

  close(data: any) {
    this.ref.close(data);
  }

}

